var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInformacoes0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.849976 4.8501C0.849976 2.64096 2.64084 0.850098 4.84998 0.850098H12.85C15.0591 0.850098 16.85 2.64096 16.85 4.8501V8.8501C16.85 11.0592 15.0591 12.8501 12.85 12.8501H0.849976V4.8501Z",
    fill: "#DFDFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.85C0 2.17142 2.17142 0 4.85 0H12.85C15.5286 0 17.7 2.17142 17.7 4.85V8.85C17.7 11.5286 15.5286 13.7 12.85 13.7H0V4.85ZM4.85 1.7C3.1103 1.7 1.7 3.1103 1.7 4.85V12H12.85C14.5897 12 16 10.5897 16 8.85V4.85C16 3.1103 14.5897 1.7 12.85 1.7H4.85Z",
    fill: "#2A2E33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85007 6C9.31952 6 9.70007 6.38056 9.70007 6.85L9.70007 9.85C9.70007 10.3194 9.31952 10.7 8.85007 10.7C8.38063 10.7 8.00007 10.3194 8.00007 9.85L8.00007 6.85C8.00007 6.38056 8.38063 6 8.85007 6Z",
    fill: "#2A2E33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84998 3.8501C9.84998 4.40238 9.40226 4.8501 8.84998 4.8501C8.29769 4.8501 7.84998 4.40238 7.84998 3.8501C7.84998 3.29781 8.29769 2.8501 8.84998 2.8501C9.40226 2.8501 9.84998 3.29781 9.84998 3.8501Z",
    fill: "#2A2E33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformacoes0);
export default __webpack_public_path__ + "static/media/icon_informacoes_0.5b64334db4c15ed0acb0724048a6b08e.svg";
export { ForwardRef as ReactComponent };